export default __webpack_public_path__ + "static/media/event-7.d59ea0b7.jpg";